import React, { useState } from 'react';
import ProjectSettingsSwitches from './project-components/ProjectSettingsSwitches';
import {
    TextField,
    Button,
    IconButton,
    Typography,
    Tooltip,
    Box,
    Modal,
    FormControlLabel,
    Switch,
    Avatar,

    Table, TableBody, TableCell, TableContainer, TableHead, TableRow,
    Paper
} from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import InfoOutlineIcon from '@mui/icons-material/InfoOutline';
import SelectDropDowns from '../DemoTabs/SelectDropDowns';


import CheckIcon from '@mui/icons-material/Check';
// import CloseIcon from '@mui/icons-material/Close';
import SendIcon from '@mui/icons-material/Send';

const modalMoveActivities = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    maxWidth: '640px',
    width: '96%',
    margin: 'auto',
    bgcolor: 'background.paper',
    boxShadow: 24,
    p: '2px',
    // border: '2px solid #0B57D0'
    border: '2px solid transparent',
    backgroundImage: 'linear-gradient(white, white), linear-gradient(136deg, rgba(0, 170, 231, 1), rgba(89, 50, 234, 1))',
    backgroundOrigin: 'border-box',
    backgroundClip: 'content-box, border-box',
    borderRadius: '12px',
};


const getInitials = (name) => {
    const words = name.split(' ');
    return words.length > 1
        ? words[0][0].toUpperCase() + words[1][0].toUpperCase()
        : name.slice(0, 2).toUpperCase();
};


const user = {
    name: 'Salona Mishra',
    image: '/assets/images/users/user1.png',
};

const StatusIcon = ({ status }) => (
    status ? (
        <img src="./assets/images/app-activity/popup-icon/check-green-icon.svg" className='img-fluid' alt='check-green-icon' />
    ) : (
        <img src="./assets/images/app-activity/popup-icon/cancel-red-icon.svg" className='img-fluid' alt='cancel-red-icon' />
    )
);
const EditPaymentDetails = ({ open, onClose }) => {
    const [billable, setBillable] = useState(true);
    const [disableActivity, setDisableActivity] = useState(false);
    const [disableIdleTime, setDisableIdleTime] = useState(false);



    // start File Type
    const [selectedFileType, setSelectedFileType] = useState('');
    const FileTypeData = [
        { name: 'None' },
        { name: 'Weekly' },
        { name: 'Twice par month' },
        { name: 'Bi-weekly' },
        { name: 'Monthly' },
    ];
    // End  File Type
    return (
        <Modal open={open} onClose={onClose} fullWidth maxWidth="sm" >
            <Box sx={{
                ...modalMoveActivities,
                display: 'flex',
                flexDirection: 'column',
                maxHeight: '90vh',
                overflow: 'hidden',
            }}>
                {/* Header */}
                <Box display="flex" justifyContent="space-between" alignItems="center"
                    sx={{ p: '20px', borderBottom: '1px solid #e0e0e0', position: 'sticky', top: 0, zIndex: 1, backgroundColor: '#fff', borderRadius: '12px 12px 0 0' }}>

                    <Typography variant="h6" fontSize={'22px'} fontWeight={'700'} sx={{ lineHeight: '1', fontFamily: 'Manrope' }}>Edit Payment Details</Typography>
                    <IconButton onClick={onClose} className='p-0'>
                        <CloseIcon sx={{ fontSize: '20px', color: '#000' }} />
                    </IconButton>
                </Box>
                {/* End Header */}

                {/* start Body sec  */}
                <Box sx={{ flex: 1, overflowY: 'auto', px: '22px', py: '26px' }} dividers>


                    <Box sx={{ display: 'flex', justifyContent: 'space-between', alignItems: 'start', marginBottom:'24px' }}>
                        <Box>
                            <Typography fontWeight="400" sx={{ fontSize: '12px', color: '#606060', fontFamily: 'Manrope' }}>Member</Typography>
                            <Box display="flex" alignItems="center" gap={1} mt={1}>
                                <Avatar src={user.image} sx={{ fontSize: '14px', background: '#0067C7', fontFamily: 'Manrope' }}>
                                    {!user.image && getInitials(user.name)}
                                </Avatar>
                                <Box>
                                    <Typography fontWeight="bold" sx={{ fontSize: '14px', color: '#373737', fontFamily: 'Manrope' }}>{user.name}</Typography>
                                    <Typography variant="body2" sx={{ fontSize: '12px', color: '#8C8C8C', fontFamily: 'Manrope' }}>
                                        Project Manager
                                    </Typography>
                                </Box>
                            </Box>
                        </Box>
                    </Box>

                    <Box sx={{ m: '0 auto 16px' }}>
                        <Typography color='#1A1F36' fontWeight={600} sx={{ fontSize: '14px', fontWeight: '600', margin: '0 auto 4px', fontFamily: 'Manrope' }}>Pay rate</Typography>
                        <Box display="flex" justifyContent="space-between" alignItems="center" sx={{ gap: '4px', position: 'relative' }}>
                            <TextField fullWidth placeholder="Enter a pay rate" variant="outlined" margin="normal"
                                sx={{
                                    marginTop: '0', '& .MuiOutlinedInput-root': {
                                        height: '40px', fontSize: '14px', color: '#64748B', fontFamily: 'Manrope',
                                        '& fieldset': { borderColor: '#D0D5DD', fontFamily: 'Manrope' },
                                    }, '& .MuiInputBase-input': { padding: '10px 18px', fontFamily: 'Manrope' },
                                }} />
                            <span style={{ fontSize: '12px', color: '#1A1F36', fontWeight: '400', position: 'absolute', right: '18px', top: '10px' }}>USD/hr</span>
                        </Box>
                    </Box>

                    <Box sx={{ m: '0 auto 24px' }}>
                        <Typography color='#1A1F36' fontWeight={600} sx={{ fontSize: '14px', fontWeight: '600', margin: '0 auto 4px', fontFamily: 'Manrope' }}>Pay period</Typography>
                        <SelectDropDowns label="User" options={FileTypeData} selectedValue={selectedFileType} onChange={setSelectedFileType} />
                    </Box>


                    <Box>
                        <Box display="flex" alignItems="center" justifyContent="space-between" sx={{ margin: '0px auto 0px' }}>
                            <Box>
                                <Typography display="flex" alignItems="center" fontWeight={'600'} sx={{ fontSize: '14px', color: '#1A1F36', lineHeight: '1', margin: '0 auto 2px', fontFamily: 'Manrope' }}>Require timesheet approval</Typography>
                            </Box>
                            <FormControlLabel
                                control={
                                    <Switch
                                        checked={disableActivity}
                                        onChange={() => setDisableActivity(!disableActivity)}
                                        color="primary"
                                        sx={{
                                            width: 40,
                                            height: 25,
                                            padding: 0,
                                            '& .MuiSwitch-switchBase': {
                                                padding: 0.5,
                                                '&.Mui-checked': {
                                                    transform: 'translateX(16px)',
                                                    color: '#fff',
                                                    '& + .MuiSwitch-track': {
                                                        backgroundColor: '#E0EEFE',
                                                        opacity: 1,
                                                        border: '1px solid #0076FE1F',

                                                    },
                                                    '& .MuiSwitch-thumb': {
                                                        backgroundColor: '#0076FE',
                                                    }
                                                },
                                            },
                                            '& .MuiSwitch-thumb': {
                                                width: 13,
                                                height: 13,
                                                boxShadow: ' 0 1px 1px #00000040',
                                                margin: '2px auto 0',
                                            },
                                            '& .MuiSwitch-track': {
                                                borderRadius: '20px',
                                                backgroundColor: '#E5E8EB',
                                                opacity: 1,
                                                border: '1px solid #D0D5DD',
                                            },
                                        }}
                                    />
                                }
                            />
                        </Box>
                    </Box>
                </Box>
                {/* End Body sec  */}

                {/* start Footer sec  */}
                <Box sx={{ p: '20px 30px', borderTop: '1px solid #e0e0e0', position: 'sticky', bottom: 0, backgroundColor: '#F2F6F9', display: 'flex', justifyContent: 'space-between', gap: 2, borderRadius: '0 0 12px 12px' }}>
                    <Button onClick={onClose} variant="outlined" className='bg-white text-capitalize' color="#595959" sx={{ p: '14px 22px', fontSize: '16px', fontWeight: '500', height: '50px', border: '1px solid #D9D9D9', fontFamily: 'Manrope' }}>
                        Cancel
                    </Button>
                    <Button variant="contained" color="primary" className='text-capitalize' sx={{ backgroundColor: '#0B57D0', p: '14px 22px', fontSize: '16px', fontWeight: '500', height: '50px', border: '1px solid #0B57D0', fontFamily: 'Manrope' }}>
                        Save
                    </Button>
                </Box>
                {/* End Footer sec  */}
            </Box>
        </Modal>
    );
};

export default EditPaymentDetails;
